/* Costack subscribe & save selector - 23 Jun 2026
 * Adds a One-time vs Subscribe & save option to the buy box. Reads the real
 * selling plan + per-variant subscribe price from /products/{handle}.js and
 * wires a selling_plan field into the product form so add-to-cart creates a
 * Shopify subscription. Product-page only. Self-contained CSS.
 */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;
  var handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];

  function money(p) { return '£' + (p / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var CSS = [
    '.cstk-sub{display:flex;flex-direction:column;gap:8px;margin:14px 0;}',
    '.cstk-sub__o{display:flex;align-items:center;gap:10px;border:1px solid #e0d5c2;border-radius:8px;padding:11px 12px;cursor:pointer;font-size:13px;}',
    '.cstk-sub__o input{margin:0;flex:0 0 auto;}',
    '.cstk-sub.is-sub .cstk-sub__o--save{border-color:#b3641c;background:#fff8ef;}',
    '.cstk-sub:not(.is-sub) .cstk-sub__o--one{border-color:#b3641c;}',
    '.cstk-sub__t{flex:1;font-weight:600;color:#231900;display:flex;flex-direction:column;line-height:1.3;}',
    '.cstk-sub__t small{font-weight:400;color:#6b6b6b;font-size:11px;margin-top:2px;}',
    '.cstk-sub__p{font-weight:700;color:#b3641c;white-space:nowrap;}'
  ].join('');

  function init() {
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (!form || document.getElementById('cstk-sub')) return;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var grp = (prod.selling_plan_groups || [])[0];
        var plan = grp && (grp.selling_plans || [])[0];
        if (!plan) return;
        var planId = plan.id;

        var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

        var wrap = document.createElement('div');
        wrap.id = 'cstk-sub'; wrap.className = 'cstk-sub';
        wrap.innerHTML =
          '<label class="cstk-sub__o cstk-sub__o--one"><input type="radio" name="cstk-pp" value="one" checked><span class="cstk-sub__t">One-time purchase</span><span class="cstk-sub__p" data-one></span></label>'
          + '<label class="cstk-sub__o cstk-sub__o--save"><input type="radio" name="cstk-pp" value="sub"><span class="cstk-sub__t">Subscribe &amp; save 10%<small>' + esc(plan.name) + ' · skip or cancel anytime</small></span><span class="cstk-sub__p" data-sub></span></label>';

        var hidden = form.querySelector('input[name="selling_plan"]');
        if (!hidden) { hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'selling_plan'; hidden.disabled = true; form.appendChild(hidden); }

        var anchor = form.querySelector('.product-form__buttons') || form.querySelector('[name="add"]') || form;
        (anchor.parentNode || form).insertBefore(wrap, anchor);

        function curVid() { var i = form.querySelector('[name="id"]'); return i ? parseInt(i.value, 10) : (prod.variants[0] || {}).id; }
        function alloc() {
          var vid = curVid();
          var v = prod.variants.find(function (x) { return x.id === vid; }) || prod.variants[0];
          var a = (v.selling_plan_allocations || []).find(function (x) { return x.selling_plan_id === planId; });
          return { v: v, a: a };
        }
        function refresh() {
          var o = alloc();
          var one = wrap.querySelector('[data-one]'); var sub = wrap.querySelector('[data-sub]');
          if (one) one.textContent = money(o.v.price);
          if (sub) sub.textContent = o.a ? money(o.a.per_delivery_price) : '';
        }
        function setMode(isSub) {
          if (isSub) { hidden.value = planId; hidden.disabled = false; } else { hidden.value = ''; hidden.disabled = true; }
          wrap.classList.toggle('is-sub', isSub);
        }
        wrap.addEventListener('change', function (e) { if (e.target && e.target.name === 'cstk-pp') setMode(e.target.value === 'sub'); });
        document.addEventListener('change', function () { setTimeout(refresh, 120); }, true);
        document.documentElement.addEventListener('cart:refresh', function () { setTimeout(refresh, 120); });
        refresh(); setMode(false);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
